import * as fromDatatype from "../../../../models/datatype-library";

export class DeliveryJobLineReportInputDto {
    
    start_time: fromDatatype.TimestampTzDatatypeInterface;
    end_time: fromDatatype.TimestampTzDatatypeInterface;
    job_no:string | any;
    sales_order_no:string | any;
    customer_name:string | any;
    trip_no:string | any;
    search_keyword: string | any;
}